// CacheKey 539759b4fa164e989e1df56402a4205d
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-JACK_HUGHSTON": {
    data_view: {
      headers: {
        defaults: {
          encounter: {
            arrival_date: "Appointment Date",
            risk_score_1_on_discharge: "ASA",
            risk_score_2_on_discharge: "Blood Charge",
            risk_score_3_on_discharge: "Recorded Value"
          },
          patient: {
            polst: "Received TXA"
          }
        }
      }
    }
  }
}

